import { Grid, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import { useFormContext } from 'react-hook-form';
import FieldContainer from '../../../FormFields/FieldContainer';
import FormButtonOptions from '../../../FormFields/FormButtonOptions';
import FormDataDivider from '../../../FormFields/FormDataDivider';
import FormTitle from '../../../FormFields/FormTitle';
import FormVendorField from '../../../FormFields/FormVendorField';
import { FILE_TYPES } from '../../../formFileTypesEnum';
import { PAYROLL } from '../../../formQuestionsEnum';
import { OUTSOURCED_COMPANY_CATEGORIES } from '../../../optionEnums';

TherapySection.propTypes = {
  permissions: PropTypes.object,
};

export default function TherapySection({ permissions }) {
  const {
    data: { outsourcedCompanyCategoriesList },
  } = useSelector((state) => state.transitions);

  const { watch } = useFormContext();
  const therapyOutsourcedCategoryId = watch(PAYROLL.THERAPY_OUTSOURCED_CATEGORY_ID.fieldName);
  const shouldShowTherapyVendor = [
    OUTSOURCED_COMPANY_CATEGORIES.CONTRACTED,
    OUTSOURCED_COMPANY_CATEGORIES.IN_HOUSE_CONTRACT_MANAGEMENT,
  ].includes(String(therapyOutsourcedCategoryId));

  return (
    [PAYROLL.THERAPY_OUTSOURCED_CATEGORY_ID.id, PAYROLL.THERAPY_VENDOR.id].some((id) => id in permissions) && (
      <>
        <Grid item xs={12}>
          <Typography variant="subtitle1" color="text.secondary">
            Therapy
          </Typography>
        </Grid>
        {PAYROLL.THERAPY_OUTSOURCED_CATEGORY_ID.id in permissions && (
          <Grid item xs={12}>
            <FieldContainer>
              <FormButtonOptions
                fieldName={PAYROLL.THERAPY_OUTSOURCED_CATEGORY_ID.fieldName}
                fieldAttributes={{
                  isEditable: permissions[PAYROLL.THERAPY_OUTSOURCED_CATEGORY_ID.id],
                  options: outsourcedCompanyCategoriesList.filter(
                    (x) =>
                      x.value === OUTSOURCED_COMPANY_CATEGORIES.CONTRACTED ||
                      x.value === OUTSOURCED_COMPANY_CATEGORIES.IN_HOUSE ||
                      x.value === OUTSOURCED_COMPANY_CATEGORIES.IN_HOUSE_CONTRACT_MANAGEMENT
                  ),
                }}
              />
            </FieldContainer>
          </Grid>
        )}
        {PAYROLL.THERAPY_VENDOR.id in permissions && shouldShowTherapyVendor && (
          <Grid item xs={12}>
            <FieldContainer>
              <FormTitle
                fieldAttributes={{
                  questionTitle: 'Therapy outsourced company',
                  fieldType: 'title',
                }}
              />
              <FormVendorField
                fieldName={PAYROLL.THERAPY_VENDOR.fieldName}
                fieldAttributes={{
                  isEditable: permissions[PAYROLL.THERAPY_VENDOR.id],
                }}
                invoiceFileTypeId={FILE_TYPES.THERAPY_OUTSOURCED_COMPANY_INVOICE}
                contractFileTypeId={FILE_TYPES.THERAPY_OUTSOURCED_COMPANY_CONTRACT}
              />
            </FieldContainer>
          </Grid>
        )}
        <FormDataDivider />
      </>
    )
  );
}
